import { FIELD_TYPES } from "constants/template-field-type";
const CTA_COLORS = {
    MAGIC: "Base",
    PURPLE: "Purple"
};
export default {
    mainHeadlineText: {
        type: FIELD_TYPES.TEXT,
        label: "Header",
        translatable: true
    },
    subHeadline: {
        type: FIELD_TYPES.TEXT,
        label: "Subheader",
        translatable: true
    },
    runningPrompts: {
        type: FIELD_TYPES.MULTIPLE_NESTED,
        label: "Running prompts",
        nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: {
                text: {
                    type: FIELD_TYPES.TEXT,
                    label: "Prompt text",
                    translatable: true
                }
            }
        }
    },
    tagsTitle: {
        type: FIELD_TYPES.TEXT,
        label: "Tags title",
        translatable: true
    },
    tags: {
        type: FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tags",
        nestedConfig: {
            type: FIELD_TYPES.NESTED,
            fields: {
                tagText: {
                    type: FIELD_TYPES.TEXT,
                    label: "Text",
                    translatable: true
                },
                tagPrompt: {
                    type: FIELD_TYPES.TEXT,
                    label: "Prompt",
                    translatable: true
                }
            }
        }
    },
    cta: {
        type: FIELD_TYPES.NESTED,
        label: "Magic CTA",
        fields: {
            text: {
                type: FIELD_TYPES.TEXT,
                label: "CTA text",
                translatable: true
            },
            color: {
                type: FIELD_TYPES.COMBO,
                label: "Color",
                options: [
                    {
                        value: CTA_COLORS.MAGIC,
                        text: "Magic"
                    },
                    {
                        value: CTA_COLORS.PURPLE,
                        text: "Purple"
                    }
                ]
            }
        }
    }
};
